<template>
  <v-card>
    <v-app-bar app dark color="primary">
      <v-toolbar-title>{{ opportunity.name }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-app-bar>
    <br />
    <v-container fluid class="mt-10">
      <v-layout row>
        <v-flex md6 xs12 px-2 mb-n5>
          <v-text-field
            v-model="search"
            outlined
            prepend-inner-icon="search"
            label="Search by name or about"
          ></v-text-field>
        </v-flex>
        <v-flex md6 xs12 px-3 mb-5>
          <v-switch
            class="mt-0"
            color="blue"
            v-model="open"
            messages="By closing applications, you will prevent more people from applying
                but people who have already applied will still be here"
            :label="`Applications: ${open ? 'Open' : 'Closed'}`"
          ></v-switch>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex
          xs12
          md6
          px-3
          pb-3
          v-for="application in applicationsSorted"
          :key="application['.uid']"
        >
          <Applicant :application="application"></Applicant>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import Applicant from "./Applicant";

export default {
  fiery: true,
  components: { Applicant },
  props: ["applications", "close", "opportunity"],
  data: function() {
    return {
      search: "",
      open: true
    };
  },
  watch: {
    open: function(val) {
      this.opportunity.open = val;
      this.$fiery.sync(this.opportunity);
    }
  },
  computed: {
    applicationsSorted: function() {
      return this.applications
        .filter(a => this.filterfunc(a))
        .sort((a1, a2) => (a1.fav === a2.fav ? 0 : a1.fav ? -1 : 1));
    }
  },
  methods: {
    filterfunc: function(a) {
      if (!this.search) {
        return true;
      }
      let searchParams = this.search.split(" ");
      let flag = false;
      searchParams.forEach(s => {
        if (
          a.FirstName.toLowerCase().includes(s.toLowerCase()) ||
          a.OtherNames.toLowerCase().includes(s.toLowerCase()) ||
          a.Surname.toLowerCase().includes(s.toLowerCase()) ||
          a.About.toLowerCase().includes(s.toLowerCase())
        ) {
          flag = true;
        }
      });
      return flag;
    }
  }
};
</script>